import React, { PureComponent } from 'react';
import { Button, Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import InputError from 'components/common/InputError';
import Spacing from 'components/common/Spacing';
import CdsCodeSelector from './CdsCodeSelector';

@inject('uiStore')
class CdsSearchForm extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    uiStore: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const { uiStore } = props;
    this.state = {
      emrEncounter: uiStore.emrEncounter || {},
    };
  }

  computeAgeAndAgeUnit = () => {
    const { emrEncounter } = this.state;
    if (!emrEncounter || !emrEncounter?.patient) {
      return {};
    }
    const { birthDate } = emrEncounter.patient;

    const start = new Date(birthDate);
    const end = new Date();

    let age = end.getFullYear() - start.getFullYear() - 1;
    if (
      end.getMonth() > start.getMonth() ||
      (end.getMonth() === start.getMonth() && end.getDate() >= start.getDate())
    ) {
      age += 1;
    }
    if (age) {
      return { age, ageUnit: 'a' };
    }
    if (end.getMonth() >= start.getMonth()) {
      age = end.getMonth() - start.getMonth() - 1;
      if (end.getDate() >= start.getDate()) {
        age += 1;
      }
    } else {
      age = 12 - start.getMonth() + end.getMonth() - 1;
      if (end.getDate() >= start.getDate()) {
        age += 1;
      }
    }
    return { age, ageUnit: 'mo' };
  };

  handleAddCode = () => {
    const { form } = this.props;
    const codeKeys = form.getFieldValue('codeKeys');
    form.setFieldsValue({
      codeKeys: [...codeKeys, codeKeys.length],
    });
  };

  handleClickResetForm = () => {
    const { form } = this.props;
    form.resetFields();
  };

  handleValidateAgeUnit = (rule, value, callback) => {
    const { form } = this.props;
    const age = form.getFieldValue('age');
    if (age && !value) {
      return callback(rule.message);
    }
    return callback();
  };

  handleValidateCode = (rule, value = {}, callback) => {
    const { code, codeSystem } = value;
    if (codeSystem && !code) {
      return callback(rule.message);
    }
    return callback();
  };

  render() {
    const { form } = this.props;
    const { emrEncounter } = this.state;
    const { getFieldDecorator, getFieldValue } = form;

    getFieldDecorator('codeKeys', { initialValue: [0] });
    const codeKeys = getFieldValue('codeKeys');

    const { age, ageUnit } = this.computeAgeAndAgeUnit();

    const codeFormItems = codeKeys.map((k, index) => (
      <Form.Item label={index === 0 ? 'Code' : ''} key={k}>
        {getFieldDecorator(`codes[${k}]`, {
          validateFirst: true,
          rules: [
            {
              validator: this.handleValidateCode,
              message: <InputError message="Code system and code are required." />,
            },
          ],
        })(<CdsCodeSelector />)}
      </Form.Item>
    ));

    let addCodeButton = null;
    const lastCodeValue = getFieldValue(`codes[${codeKeys[codeKeys.length - 1]}]`);
    if (lastCodeValue && lastCodeValue.codeSystem && lastCodeValue.code) {
      addCodeButton = (
        <Button type="default" icon="plus" block onClick={this.handleAddCode}>
          Add code
        </Button>
      );
    }

    return (
      <Form onSubmit={this.handleSubmit} colon={false}>
        <Form.Item label="Search term">{getFieldDecorator('searchTerm')(<Input />)}</Form.Item>
        <Row gutter={10}>
          <Col span={8}>
            <Form.Item label="Sex">
              {getFieldDecorator('sex', {
                initialValue: emrEncounter?.patient?.sex || undefined,
              })(
                <Select>
                  {Object.entries({ M: 'Male', F: 'Female', U: 'Unknown' }).map(([key, label]) => (
                    <Select.Option key={key} value={key}>
                      <div id={`cds-option-${key}`}>{label}</div>
                    </Select.Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Age">
              {getFieldDecorator('age', {
                initialValue: age,
              })(<InputNumber min={0} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label=" ">
              {getFieldDecorator('ageUnit', {
                initialValue: ageUnit,
                rules: [
                  {
                    validator: this.handleValidateAgeUnit,
                    message: <InputError message="Age unit is required." />,
                  },
                ],
              })(
                <Select>
                  {Object.entries({ a: 'year/s', mo: 'month/s' }).map(([key, label]) => (
                    <Select.Option key={key} value={key}>
                      <div id={`cds-option-${key}`}>{label}</div>
                    </Select.Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>
        </Row>
        {codeFormItems}
        <Row gutter={10}>
          <Col span={8} />
          <Col span={8}>{addCodeButton}</Col>
          <Col span={8}>
            <Button type="default" icon="delete" block onClick={this.handleClickResetForm}>
              Reset form
            </Button>
          </Col>
        </Row>
        <Spacing size={40} />
      </Form>
    );
  }
}

const WrappedCdsSearchForm = Form.create({ name: 'cdsSearch' })(CdsSearchForm);

export default WrappedCdsSearchForm;
